'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('carrierService', carrierService);

	carrierService.$inject = [
		'$http', '$log', '$stateParams'
	];

	function
	carrierService($http, $log, $stateParams) {

		return {
			getCarriers: getCarriers,
			updateCarrierNote: updateCarrierNote,
			deleteCarrierNote: deleteCarrierNote,
			updateCarrierStatus: updateCarrierStatus,
			getCarrierPrimaryContact: getCarrierPrimaryContact,
			searchCarriers: searchCarriers,
			exportCarriers: exportCarriers,
			exportAllCarriers: exportAllCarriers,
			getCarrierDetails: getCarrierDetails
		};

		function exportCarriers(carriers) {
			var request = {
				carriers: carriers
			};
			request = brokerImpersonationHelper(request);

			return $http.post('/api/carrierlookup/exportcarriers', request);
		}

		function exportAllCarriers(filter) {

			return $http.get('/api/carrierlookup/exportallcarriers',
				{ params: { filter: filter, brokerId: $stateParams.brokerId } });

		}

		function updateCarrierStatus(carriers) {
			var request = {
				carriers: carriers
			};
			request = brokerImpersonationHelper(request);

			return $http.put('/api/carrierlookup/associatedcarrierstatus', request);

		}

		function getCarriers(filter, startRow, carrierCount, sortColumn, isSortDescending, showRowCount) {
			var request = {
				filter: filter,
				startRow: startRow,
				carrierCount: carrierCount,
				sortColumn: sortColumn,
				isSortDescending: isSortDescending,
				showRowCount: showRowCount
			};

			request = brokerImpersonationHelper(request);

			return $http.post('/api/carrierlookup/associatedcarriers', request);
		}

		function updateCarrierNote(carrierId, note) {
			var request = {
				CarrierId: carrierId,
				IsDelete: false,
				Notes: note
			};

			request = brokerImpersonationHelper(request);

			return $http.put('/api/carrierlookup/carriernotes', request);
		}

		function deleteCarrierNote(carrierId) {
			var request = {
				carrierId: carrierId
			};
			request = brokerImpersonationHelper(request);

			return $http.put('/api/carrierlookup/deletecarriernotes', request);
		}

		function getCarrierPrimaryContact(carrierId) {
			return $http.get('/api/carrierlookup/carrierprimarycontact',
				{ params: { carrierId: carrierId, brokerId: $stateParams.brokerId } });
		}

		function searchCarriers(searchValue,
			searchValue2,
			searchType,
			startRow,
			carrierCount,
			sortColumn,
			isSortDescending,
			showRowCount) {

			if (searchType === 'timeFrame') {

				var request = {
					filter: '',
					fromDate: searchValue,
					toDate: searchValue2,
					startRow: startRow,
					carrierCount: carrierCount,
					sortColumn: sortColumn,
					isSortDescending: isSortDescending,
					showRowCount: showRowCount
				};

				request = brokerImpersonationHelper(request);

				return $http.post('/api/carrierlookup/associatedcarriers', request);
			} else {
				request = {
					searchValue: searchValue,
					searchType: searchType,
					startRow: startRow,
					carrierCount: carrierCount,
					sortColumn: sortColumn,
					isSortDescending: isSortDescending,
					showRowCount: showRowCount
				};

				request = brokerImpersonationHelper(request);

				return $http.post('/api/carrierlookup/searchassociatedcarriers', request);
			}
		}

		function brokerImpersonationHelper(request) {
			if ($stateParams.brokerId) {
				request.brokerId = $stateParams.brokerId;
			}

			return request;
		}

		function getCarrierDetails(carrierId, brokerId) {
			return $http.get('/api/carrierlookup/carrierAssociation', { params: { carrierId: carrierId, brokerId: brokerId } });
		}
	}
})();
